import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const SignupsByUtmTab: React.FC = () => (
  <LookerEmbedTab
    path="dashboards/497"
    translationKey="reports.customer.tabs.signups_by_utm"
  />
)

export default SignupsByUtmTab
